import { useState } from "react";
import { faqItems } from "@/mocks/gossip";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[300px_1fr]">
          <div>
            <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-secondary-500">
              追更之前 · 先看答疑
            </p>
            <h2 className="font-display text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
              常见疑问
              <br />
              一次问清楚
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              还没搞懂九色黑料新进展怎么更新、存档怎么回看？看完这几条，基本就能顺畅吃瓜了。
            </p>
          </div>

          <div className="divide-y divide-background-200 rounded-xl border border-background-200 bg-background-50">
            {faqItems.map((item, idx) => {
              const open = openIdx === idx;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : idx)}
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-6"
                  >
                    <span className="flex items-center gap-3">
                      <span className="font-mono text-xs text-secondary-400">{String(idx + 1).padStart(2, "0")}</span>
                      <span className="text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                    </span>
                    <i
                      className={`text-lg text-secondary-500 transition-transform duration-200 ${
                        open ? "rotate-45 text-primary-600" : ""
                      } ri-add-line`}
                    ></i>
                  </button>
                  {open && (
                    <div className="px-4 pb-5 pl-[2.75rem] text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-[3.6rem]">
                      {item.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}